/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import formattedAmount from './formattedAmount';

function StaticProduct(props) {
  const { currency, quantity, unitPrice } = props;

  return (
    <div className="cart-summary__accordion-sub-item-details-category">
      <span>
        {parseFloat(quantity)} x {formattedAmount(unitPrice, currency)}
      </span>
    </div>
  );
}

StaticProduct.defaultProps = {
  unitPrice: '0.0',
  quantity: '0.0',
};

StaticProduct.propTypes = {
  currency: PropTypes.string.isRequired,
  unitPrice: PropTypes.string,
  quantity: PropTypes.string,
};

export default StaticProduct;
